import {Action, State, StateContext, Store} from '@ngxs/store';
import {Injectable, NgZone} from '@angular/core';
import {
  AddDashboard,
  AddWidgetToDashboard,
  CancelEditWidget,
  DeleteDashboard,
  DuplicateDashboard,
  DuplicateWidget,
  EditWidget,
  FetchDashboards,
  MoveWidget,
  RemoveWidgetFromDashboard,
  ReorderDasboards,
  SaveWidget,
  SetActiveDashboard,
  UpdateDashboard
} from './dashboard.actions';
import {DashboardService} from '../services/dashboard.service';
import {tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {append, insertItem, patch, removeItem, updateItem} from '@ngxs/store/operators';
import {v4 as uuid} from 'uuid';
import {Dashboard, GridItem, Widget} from '../../core/models';
import {HistoryService} from "../../history/services/history.service";
import {moveItemInArray} from "@angular/cdk/drag-drop";
import {Router} from "@angular/router";


export class DashboardStateModel {
  public items: Array<Dashboard>;
  public active: Dashboard | null;
  public loading: boolean;
  public editWidget: any;
  public dataLoaded: boolean;
  public justAdded: number;
  public justDropped: number;
}


@State<DashboardStateModel>({
  name: 'dashboard',
  defaults: {
    items: [],
    active: null,
    loading: false,
    editWidget: null,
    dataLoaded: false,
    justAdded: null,
    justDropped: null
  }
})
@Injectable()
export class DashboardState {

  @Action(FetchDashboards)
  fetch(ctx: StateContext<DashboardStateModel>, action: FetchDashboards) {
    const state = ctx.getState();
    ctx.patchState({loading: true});

    return this.dashboardService.fetchDashBoards().pipe(
      tap((response: any) => {
        ctx.patchState({
          items: response,
          loading: false,
          dataLoaded: true
        });
      })
    );
  }

  @Action(UpdateDashboard)
  update(ctx: StateContext<DashboardStateModel>, action: UpdateDashboard) {
    return this.dashboardService.updateDashboard(action.id, action.payload).pipe(
      tap((response: any) => {
        const state = ctx.getState();
        if(action.id == state.active.id) {
          ctx.setState(
            patch({
              name: response.name,
              active: patch({conf: response.conf, updated_at: response.updated_at}),
              items: updateItem((item: any) => item.id === action.id, response)
            })
          );
        } else {
          ctx.setState(
            patch({
              items: updateItem((item: any) => item.id === action.id, response)
            })
          );
        }
         this.historyService.addAction({
           'text': `изменил дашборд "${action.payload.name}"`,
           'model': 'dashboard',
           'operation': 'update',
           'object_id': action.id
         })

      })

    );

  }

  @Action(ReorderDasboards)
  reorderDashboars(ctx: StateContext<DashboardStateModel>, action: ReorderDasboards) {
    return this.dashboardService.updateDashboard(action.id, action.payload).pipe(
      tap((response: any) => {
        const state = ctx.getState();
        let items = state.items.slice(0);
        moveItemInArray(items, action.previousIndex, action.currentIndex);
        ctx.setState(
          patch({
            items: items
          })
        );
      })

    );

  }

  @Action(SetActiveDashboard)
  setActive(ctx: StateContext<DashboardStateModel>, action: SetActiveDashboard) {
    const state = ctx.getState();
    this.router.navigate(['dashboard'], {queryParams: {id: action.id}});
    console.log(action.id);
    console.log(state.items);
    console.log(state.items.filter((x) => x.id == action.id));
    ctx.patchState({active: state.items.filter((x) => x.id == action.id)[0]});
  }

  @Action(AddWidgetToDashboard)
  addWidget(ctx: StateContext<DashboardStateModel>, action: AddWidgetToDashboard) {
    const id = uuid();
    const s = ctx.getState();
    let name = 'Новый виджет';

    const pattern = new RegExp(`${name}( \(\d+\))*`, 'i');
    const same = s.active.conf.widgets.filter((tab) => pattern.exec(tab.name) != null).length;
    if(same > 0) {
      name = `${name} (${same})`;
    }

    ctx.setState(
      patch({
        active: patch({
          conf: patch({
            widgets: append([{
              id: id,
              name: name,
              grid: {x: action.x, y: action.y, cols: 6, rows: 6},
              benchmarks: [],
              filters: [],
              indicators: []
            }])
          })
        })
      })
    );

    this.historyService.addAction({
      'text': `создал виджет "${name}"`,
      'model': 'dashboard',
      'operation': 'create',
      'object_id': id
    });

    const state = ctx.getState();

    return this.dashboardService.updateDashboard(state.active.id, state.active).pipe(
      tap((response: any) => {
        ctx.setState(
          patch({
            items: updateItem((item: any) => item.id === state.active.id, patch({
              conf: state.active.conf
            }))
          })
        );
      })
    );

  }

  @Action(RemoveWidgetFromDashboard)
  removeWidget(ctx: StateContext<DashboardStateModel>, action: RemoveWidgetFromDashboard) {

    ctx.setState(
      patch({
        active: patch({
          conf: patch({
            widgets: removeItem((widget: Widget) => {
              return widget.id === action.id;
            })
          })
        })
      })
    );

    this.historyService.addAction({
      'text': `удалил виджет "${action.name}"`,
      'model': 'widget',
      'operation': 'create',
      'object_id': action.id
    });

    const state = ctx.getState();

    return this.dashboardService.updateDashboard(state.active.id, state.active).pipe(
      tap((response: any) => {
        ctx.setState(
          patch({
            items: updateItem((item: any) => item.id === state.active.id, patch({
              conf: patch({
                widgets: removeItem((widget: Widget) => {
                  return widget.id === action.id;
                })
              })
            }))
          })
        );
      })
    );

  }

  @Action(EditWidget)
  editWidget(ctx: StateContext<DashboardStateModel>, action: EditWidget) {
    const state = ctx.getState();

    this.router.navigate(['dashboard'], {queryParams: {id: action.dashboardId, widget: action.widget.id}});
    ctx.patchState({
      editWidget: {
        dashboardId: action.dashboardId,
        widget: action.widget
      }
    });

  }

  @Action(CancelEditWidget)
  cancelEditWidget(ctx: StateContext<DashboardStateModel>, action: CancelEditWidget) {
    const state = ctx.getState();

    this.router.navigate(['dashboard'], {queryParams: {id: state.editWidget.dashboardId}});
    ctx.patchState({
      editWidget: null
    });
  }

  @Action(DuplicateWidget)
  duplicateWidget(ctx: StateContext<DashboardStateModel>, action: DuplicateWidget) {
    const state = ctx.getState();

    const newWidget = {...action.payload} as Widget;

    newWidget.id = uuid();
    const items = state.active.conf.widgets.map(v => v.grid);
    newWidget.grid = this.getWidgetPosition(items, newWidget.grid);

    let name = newWidget.name;
    const res = /(.*)\((\d+)\)/i.exec(name);
    if(res) {
      name = res[1].trim();
    }

    const pattern = new RegExp(`${name}( \(\d+\))*`, 'i');
    const same = state.active.conf.widgets.filter((tab) => pattern.exec(tab.name) != null).length;
    if(same > 0) {
      newWidget.name = `${name} (${same})`;
    }

    ctx.setState(
      patch({
        active: patch({
          conf: patch({
            widgets: append([newWidget])
          })
        })
      })
    );

    // ctx.patchState({active: state.items[action.index]});
  }

  @Action(AddDashboard)
  addDashboard(ctx: StateContext<DashboardStateModel>, action: AddDashboard) {
    return this.dashboardService.createDashboard(action.payload).pipe(
      tap((response: any) => {
        ctx.setState(
          patch({
            items: insertItem(response, response.index + 1),
            active: response,
            justAdded: response.id
          })
        );

        this.historyService.addAction({
          'text': `создал дашборд "${response.name}"`,
          'model': 'dashboard',
          'operation': 'create',
          'object_id': response.id
        });

        this.ngZone.run(() => {
          this.snackBar.open('Сохранено');
        });
      })
    );
  }

  @Action(DeleteDashboard)
  deleteDashboard(ctx: StateContext<DashboardStateModel>, action: DeleteDashboard) {

    const state = ctx.getState();

    return this.dashboardService.deleteDashboard(action.id).pipe(
      tap((response) => {

        const payload = {
          items: removeItem((i: any) => i.id === action.id),
          justDropped: action.id
        } as any;


        if (state.items.length < 1) {
          payload.active = null;
        }

        this.historyService.addAction({
          'text': `удалил дашборд "${action.name}"`,
          'model': 'dashboard',
          'operation': 'delete',
          'object_id': action.id
        });

        ctx.setState(patch(payload));

      })
    );

  }

  @Action(SaveWidget)
  saveWidget(ctx: StateContext<DashboardStateModel>, action: SaveWidget) {

    ctx.setState(
      patch({
        active: patch({
          conf: patch({
            widgets: updateItem((widget: any) => widget.id === action.widget.id, patch(action.payload))
          })
        })
      })
    );

    this.historyService.addAction({
      'text': `изменил виджет "${action.widget.name}"`,
      'model': 'widget',
      'operation': 'update',
      'object_id': action.widget.id
    });

    const state = ctx.getState();

    return this.dashboardService.updateDashboard(state.active.id, state.active).pipe(
      tap((response: any) => {
        this.ngZone.run(() => {
          this.snackBar.open('Сохранено');
        });
      })
    );

  }

  @Action(DuplicateDashboard)
  duplicateDashboard(ctx: StateContext<DashboardStateModel>, action: DuplicateDashboard) {
    const state = ctx.getState();
    let payload;
    if(action.widget) {
      payload = {...action.widget};
    } else {
      payload =  {...state.active};

    }
    delete payload.id;
    this.store.dispatch(new AddDashboard(payload));
  }

  @Action(MoveWidget)
  moveWidget(ctx: StateContext<DashboardStateModel>, action: MoveWidget) {

    this.store.dispatch(new RemoveWidgetFromDashboard(action.widget.id, action.widget.name));
    const state = ctx.getState();
    const dashboard = state.items.filter(item => item.id === action.toDashboardId)[0];
    const items = dashboard.conf.widgets.map(v => v.grid);
    const item: GridItem = {x: 0, y:0, cols: action.widget.grid.cols, rows: action.widget.grid.rows};
    action.widget.grid = this.getWidgetPosition(items, item);

    ctx.setState(
      patch({
        items: updateItem(
          (item: any) => item.id === action.toDashboardId,
          patch({conf: patch({widgets: append([action.widget])})})
        )
      })
    );

    const data = state.items.filter((x) => x.id === action.toDashboardId)[0];

    return this.dashboardService.updateDashboard(action.toDashboardId, data).pipe(
      tap((response: any) => {
        this.ngZone.run(() => {
          this.snackBar.open('Виджет перемещен');
        });
      })
    );
  }

  getWidgetPosition(items: Array<GridItem>, item: GridItem): GridItem {
    const columns = Math.max.apply(null, items.map(v => v.x + v.cols));
    const rows = Math.max.apply(null, items.map(v => v.y + v.rows));

    for(let y=item.y ; y<rows ; y++) {
      for(let x=item.x ; x<columns-1 ; x++) {
        const checkItem = {x: x, y: y, cols: item.cols, rows: item.rows};
        if(this.checkCollision(items, checkItem) === false) {
          return checkItem;
        }
      }
    }
    return {x: 0, y: rows+1, cols: item.cols, rows: item.rows};
  }

  checkCollision(items: Array<GridItem>, item: GridItem) {
      for (let i=0 ; i < items.length ; i++) {
        if(this.checkCollisionTwoItems(items[i], item)) {
          return true;
        }
      }
      return false;
  }

  checkCollisionTwoItems(item: GridItem, item2: GridItem) {
    return item.x             < item2.x + item2.cols
        && item.x + item.cols > item2.x
        && item.y             < item2.y + item2.rows
        && item.y + item.rows > item2.y;
  }

  constructor(private dashboardService: DashboardService,
              private historyService: HistoryService,
              private ngZone: NgZone,
              private snackBar: MatSnackBar,
              private router: Router,
              private store: Store) {
  }

}
